const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};

export const HeaderStandard = [
  [
    { text: 'S.No.', style: style1 },
    { text: 'Type', style: style1 },
    { text: 'Check Points', style: style1 },
    { text: 'Method of Checking', style: style1 },
    { text: 'CTX', style: style1 },
    { text: 'DESCRIPTION', style: { ...style1, minWidth: '300px' } },
    { text: 'Result (OK/NG)', style: style1 },
    { text: 'Action Taken on Non-Conformity', style: style1 },
    { text: 'Remarks', style: style1 },
  ],
];

export const headerConstant = {
  tableCompHeadTitle: 'ANNUAL PREVENTIVE CHECKSHEET ',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  getById: 'annualPreventivePlanNewStatusCheckListRoute',
  post: 'annualPreventivePlanNewStatusCheckListRoute',
  update: 'annualPreventivePlanNewStatusCheckListRoute',
  delete: 'annualPreventivePlanNewStatusCheckListRoute',
  // below this master checklist api
  masterCheckListAutoComplete:
    'annualPreventivePlanMasterNewChecklistRoute/masterCheckListAutoComplete',
  getMasterCheckListById: 'annualPreventivePlanMasterNewChecklistRoute',
};

export const navigationConstant = {};
